import styled from 'styled-components';

import theme from '../../../styles/defaultTheme';

export const Card = styled.div`
    background: ${(props) => props.theme.white};
    border-radius: 8px;
`;

export const Container = styled.div`
    width: 100%;
    &:last-child{
        margin-bottom:32px;
    }
`;

export const LeftContent = styled.div`
    display: flex;
    align-items: center;
`;

export const AttachContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    margin: 4px 0;
    background-color: ${(props) => props.theme.white} !important;
    border: 1px solid ${(props) => props.theme.borderWhite};
    border-radius: 8px;

    &.doc {
        padding: 0 22px;
    }

    &.doc:last-child {
        padding: 12px 24px;
    }
`;

export const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    margin-right: 10px;

    img {
        width: 30px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    & span {
        font-size: ${theme.font.size14};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 500px;
    }

    & .link {
        color: ${(props) => props.theme.greyLink} !important; 
    }

    @media(max-width: 900px) {
        & span {
            max-width: 150px;
        }
    }

    @media(max-width: 600px) {
        & span {
            max-width: 120px;
        }
    }
    
    & .name {
        font-weight: bold;
    }

    & label,
    & span {
        color: ${(props) => props.theme.grey};
    }

    & span.link {
        color: ${(props) => props.theme.grey};
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const Actions = styled.div`
    color: ${(props) => props.theme.orange};
    display: flex;

    span {
        color: ${(props) => props.theme.orangeLink};
    }
    
    & .attach-icon {
        display: flex;
        align-items: center;
        cursor: pointer;

        input {
            display: none;
        }
        
        span[class*="material-icons"] {
            margin-right: 8px; 
        }
        
        span:not([class*="material-icons"]) {
            font-size: ${theme.font.size16};
            font-weight: bold;
            text-decoration: underline;
        }
    }

    span[class*="material-icons"] {
        cursor: pointer;
    }
    
    & div:not(.attach-icon):first-child  span[class*="material-icons"] {
        margin-right: 15px;
    }
`;
